export const BO_NOTIFICATION_SUBSCRIBER_DELIMITER = ',';
export const SERVICE_TAG_VARIANT_DELIMITER = '%';
export const SELECTED_SERVICE_DELIMITER = '%';
